<template>
  <div class="full">
    <div class="bg full" style="text-align:center;">
      <div class="content" style="margin-top:220px;">
          欢迎进入游戏
      </div>
      <div class="okbtn" style="margin-top:20px;">
          <button @click="GotoIndex()" style="width:50%;height:30px;color:red;">Go!</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
export default {
  data() {
    return {
      test:''
    }
  },
  methods: {
    async onload(){
      const fp = await FingerprintJS.load();
      //使用手机号码登陆验证，如果服务器Redis中有该数据，则认为当前手机号在线
      // var phone = localStorage.getItem("phoneNo");
      // if(!phone)
      // {
      //   phone="";
      // }

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const result = await fp.get();
    
      // This is the visitor identifier:
      const visitorId = result.visitorId;
        console.log(visitorId);
        const params = {
          deviceId: visitorId,
        };
        const res = await axios.get(
          "http://gameserver.9help.net/ManageCenter/DeviceLogin",
          {
            params,
          }
        );
        const { data } = res;
        if (data.code == 1) {
          this.$router.push({ path: "/login" });
        }
    },
    GotoIndex(){
      this.$router.push({ path: "/index" });
    }
  },
  mounted(){
    this.onload();
  }
};
</script>
